module.exports = __webpack_public_path__ + "static/media/Laundry_Myaccount_Landing.744d80d6.jpg";